/*
 * DRV: flytter billed-badges (rabat / fri fragt) over på det SYNLIGE produktbillede.
 * Nødvendigt fordi temaet laver en JS-klon af media-kolonnen, hvor originalen (med
 * vores server-renderede badge) bliver skjult.
 */
(function () {
  function visibleWrapper() {
    var ws = document.querySelectorAll('.product--drv-split .product__media-wrapper');
    for (var i = 0; i < ws.length; i++) {
      if (getComputedStyle(ws[i]).display !== 'none' && ws[i].offsetWidth > 0) return ws[i];
    }
    return null;
  }

  function move() {
    var badge = document.querySelector('.drv-image-badges');
    if (!badge) return true; // intet at flytte
    var vis = visibleWrapper();
    if (!vis) return false;
    vis.style.position = 'relative';
    if (badge.parentElement !== vis) vis.appendChild(badge);
    return true;
  }

  var tries = 0;
  function loop() {
    if (move() || tries > 25) return;
    tries++;
    setTimeout(loop, 150);
  }

  if (document.readyState !== 'loading') loop();
  else document.addEventListener('DOMContentLoaded', loop);
  document.addEventListener('shopify:section:load', function () { tries = 0; loop(); });
})();
